<template>
<div class="foot" :style="`background:url(${backgroundd}) no-repeat center center;    background-size: 100% 100%;`">
	<div style="width: 90%;margin-left: 5%;">
		<div style=" float: left;font-size: 16px; color: #131313;margin-top: 15px;">
			<span style="line-height: 40px;"> 
				<span @click="aboutsb_f" style="cursor: pointer;">关于我们</span>  |  
				<span @click="fuwu_f" style="cursor: pointer;">服务范围</span>  |  
				<span @click="product_f" style="cursor: pointer;">典范项目</span>  |  
				<span @click="lianxi_f" style="cursor: pointer;">朗建之窗</span>  |  
				<span @click="news_f" style="cursor: pointer;">精英招聘</span>
			</span><br/>
			<span style="font-size: 14px;color: #808081;">© 2021朗建国际设计机构，保留所有权利  鲁ICP备19026161号</span>
		</div>
		<div style=" float: right; height: 100px; font-size: 16px;">
			<div style="float:left; height: 100px;line-height: 100px;margin-right: 40px;">
				<img src="../assets/img/logodi.png" style="margin-top: 10px;">
			</div>
			<div style="float:right; line-height: 100px;"><img src="../assets/img/erweima.jpg" style="width:80px;    margin-top: 10px;">
				<div style="width: 20px; float: right; color: #ccc; font-size: 12px; line-height: 14px; margin-top: 15px; color: #101010; margin-left: 5px;">查看手机站</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
  name: "foder",
  props: {
    title: {
      type: String,
      default: "../assets/img/bgtop.jpg"
    },
	backgroundd:{
		type: String,
		default: require('../../src/assets/img/dibu_02.jpg')
	},
    img: {
      type: String,
      default: "../assets/img/bgtop.jpg"
    }
  },
  methods:{
	  aboutsb_f(){
	  		  this.$router.push('/abouts')
	  },
	  fuwu_f(){
	  	this.$router.push('/fuwu')
	  },
	  lianxi_f(){
	  	this.$router.push('/lianxi')
	  },
	  news_f(){
	  	this.$router.push('/zhaopin')
	  },
	  product_f(){
	  	this.$router.push('/Product')
	  		},
  }
};
</script>

<style lang="scss" scoped>
	.foot{
		width: 100%;height: 100px;color: #FFFFFF;position: absolute;bottom: 0px;z-index: 10;
	}
.banner {
  width: 100%;
  height: 300px;
  display: flex;
  position: relative;
  overflow: hidden;
  background-color: #fff;

  .mm {
    position: absolute;
    width: 100%;
    height: 100%;

    padding: 10px;
    margin: -10px;
    filter: blur(10px);

    background-image: url(../assets/img/bgtop.jpg);
    background-position: center;
    background-size: 100%;
  }

  img {
    position: absolute;
    //width: 1240px;
    height: 100%;
    left: 50%;
    transform: translate(-50%, 0);
  }

  &-title {
    position: absolute;
    color: #fff;
    font-size: 45px;
    font-weight: 400;
    line-height: 300px;
    text-align: center;
    width: 100%;
  }
}
</style>